import React from 'react';
import { motion } from 'framer-motion';

/**
 * Page footer component
 * Contains copyright information and useful links
 */
const Footer = () => {
  return (
    <footer className="py-6 px-4 sm:px-6 lg:px-8 mt-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center">
        <motion.div 
          className="text-sm text-gray-500 mb-4 sm:mb-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          © {new Date().getFullYear()} Random Animal Generator
        </motion.div>
        
        <motion.div 
          className="flex space-x-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          <a 
            href="/articles" 
            className="text-sm text-primary hover:text-primary-dark transition-colors"
          >
            Articles
          </a>
          <a 
            href="/about" 
            className="text-sm text-primary hover:text-primary-dark transition-colors"
          >
            About Us
          </a>
          <a 
            href="/privacy" 
            className="text-sm text-primary hover:text-primary-dark transition-colors"
          >
            Privacy Policy
          </a>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 